import { render, staticRenderFns } from "./SubgroupPaperworkList.vue?vue&type=template&id=6d7ed6cb&"
import script from "./SubgroupPaperworkList.vue?vue&type=script&lang=js&"
export * from "./SubgroupPaperworkList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports